/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';

import { GUIComponent, DynamicContent, HisGlobalDataService } from 'hisng';

import { DynamicContentUtils } from './dynamic-content-utils';

@Injectable()
export class DynamicFormGroupUtils {

    private readonly FORMGROUPVALUE = 'res_dynamicformGroupValue';

    constructor( private globalDataService: HisGlobalDataService,
        private dynamicContentUtils: DynamicContentUtils ) {
    }

    /* set dynamic component for object from dynamic container components */
    public setDynamicComponentObject( dynamicContentObject: DynamicContent ) {
        if ( dynamicContentObject._dynamicComponent ) {
            let formGroupValue: Record<string, any> = {};
            let globalDataFormGroupValue = this.globalDataService.getData( this.FORMGROUPVALUE );
            if ( globalDataFormGroupValue ) {
                dynamicContentObject._dynamicComponent.guiComponent.children.forEach( ( tabChild: GUIComponent ) => {
                    tabChild.children.forEach( ( fieldsetChild: GUIComponent ) => {
                        if ( fieldsetChild ) {
                            if ( !formGroupValue[fieldsetChild.name] ) {
                                formGroupValue[fieldsetChild.name] = globalDataFormGroupValue[fieldsetChild.name];
                            } else {
                                Object.assign( formGroupValue[fieldsetChild.name], globalDataFormGroupValue[fieldsetChild.name] );
                            }
                        }
                    } );
                } );
            }
            dynamicContentObject._dynamicComponent = this.dynamicContentUtils.convertFormGroupValueToDynamicObjects(
                formGroupValue, dynamicContentObject._dynamicComponent );
        }
    }

}
